import {
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  DatePicker,
  FiltrosChips,
  FiltrosDrawer,
  FiltrosSecao,
  FormControlLabel,
  TextField,
} from "../../../../components";
import { value } from "../../../../helpers";
import { formatDate } from "../../../../utils";
import {
  PERIODO_PRESETS,
  formatarDataChip,
  intervaloPreset,
} from "../monitor-financeiro";

const POPPER_SX = { sx: { zIndex: 9000 } };

function chipsAtivos(filtros, acessosEmpresas, aplicar) {
  const remover = (patch) => aplicar({ ...filtros, ...patch });
  const chips = [
    {
      key: "periodo",
      icon: "ph-calendar-blank",
      label: `${formatarDataChip(filtros.de)} – ${formatarDataChip(
        filtros.ate,
      )}`,
    },
  ];
  if (acessosEmpresas.length > 0) {
    filtros.empresas.forEach((e) =>
      chips.push({
        key: `emp-${e.id}`,
        icon: "ph-buildings",
        label: e.razaoSocial,
        onDelete: () =>
          remover({ empresas: filtros.empresas.filter((x) => x.id !== e.id) }),
      }),
    );
  }
  filtros.contas.forEach((c) =>
    chips.push({
      key: `conta-${c.id}`,
      icon: "ph-bank",
      label: c.nome,
      onDelete: () =>
        remover({ contas: filtros.contas.filter((x) => x.id !== c.id) }),
    }),
  );
  if (filtros.centroCusto) {
    chips.push({
      key: "centroCusto",
      icon: "ph-target",
      label: filtros.centroCusto.descricao,
      onDelete: () => remover({ centroCusto: null }),
    });
  }
  if (filtros.mostrarContasVencidasReceberPagar) {
    chips.push({
      key: "mostrarContasVencidasReceberPagar",
      icon: "ph-eye",
      label: "Mostrar todas Contas Vencidas",
      onDelete: () => remover({ mostrarContasVencidasReceberPagar: false }),
    });
  }
  return chips;
}

function MonitorFinFiltros({
  filtros,
  filtrosPadrao,
  onAplicar,
  listas,
  acessosEmpresas,
  draft,
  setDraft,
  open,
  setOpen,
}) {
  const setCampo = (campo, valor) =>
    setDraft((prev) => ({ ...prev, [campo]: valor }));

  const aplicar = () => {
    onAplicar(draft);
    setOpen(false);
  };

  const onChangeData = (campo, date) =>
    setCampo(
      campo,
      date && date !== "Invalid Date" ? formatDate.toSend(date) : "",
    );

  return (
    <>
      <FiltrosChips chips={chipsAtivos(filtros, acessosEmpresas, onAplicar)} />

      <FiltrosDrawer
        open={open}
        onClose={() => setOpen(false)}
        onLimpar={() => setDraft(filtrosPadrao)}
        onAplicar={aplicar}
      >
        <FiltrosSecao titulo="Período" gap={1.5}>
          <Box display="flex" gap={1}>
            <DatePicker
              label="Data Inicial"
              format="dd/MM/yyyy"
              value={value.date(draft.de)}
              onChange={(date) => onChangeData("de", date)}
              sx={{ width: "100%" }}
            />
            <DatePicker
              label="Data Final"
              format="dd/MM/yyyy"
              value={value.date(draft.ate)}
              onChange={(date) => onChangeData("ate", date)}
              sx={{ width: "100%" }}
            />
          </Box>
          <Box display="flex" flexWrap="wrap" gap={0.75}>
            {PERIODO_PRESETS.map((preset) => (
              <Chip
                key={preset.key}
                size="small"
                clickable
                variant="outlined"
                label={preset.label}
                onClick={() =>
                  setDraft((prev) => ({ ...prev, ...intervaloPreset(preset) }))
                }
              />
            ))}
          </Box>
        </FiltrosSecao>

        <FiltrosSecao titulo="Origem dos lançamentos">
          {acessosEmpresas.length > 0 && (
            <Autocomplete
              multiple
              filterSelectedOptions
              options={acessosEmpresas}
              disableCloseOnSelect
              getOptionLabel={(opt) => opt?.razaoSocial ?? ""}
              isOptionEqualToValue={(opt, val) =>
                String(opt?.id) === String(val?.id)
              }
              value={draft.empresas}
              onChange={(_, val) => setCampo("empresas", val)}
              slotProps={{ popper: POPPER_SX }}
              renderInput={(params) => (
                <TextField {...params} label="Unidade(s)" />
              )}
            />
          )}

          <Autocomplete
            multiple
            filterSelectedOptions
            options={listas.contas}
            disableCloseOnSelect
            getOptionLabel={(opt) => opt?.nome ?? ""}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            value={draft.contas}
            onChange={(_, val) => setCampo("contas", val)}
            slotProps={{ popper: POPPER_SX }}
            renderInput={(params) => (
              <TextField {...params} label="Contas / Caixa" />
            )}
          />

          <Autocomplete
            options={listas.centrosCusto}
            getOptionLabel={(opt) => opt?.descricao ?? ""}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            value={draft.centroCusto}
            onChange={(_, val) => setCampo("centroCusto", val)}
            slotProps={{ popper: POPPER_SX }}
            renderInput={(params) => (
              <TextField {...params} label="Centro de Custo" />
            )}
          />

          <FormControlLabel
            label="Mostrar todas às Contas Vencidas à Receber/Pagar"
            labelPlacement="end"
            control={
              <Checkbox
                name="mostrarContasVencidasReceberPagar"
                checked={draft.mostrarContasVencidasReceberPagar}
                onChange={(e) =>
                  setCampo(
                    "mostrarContasVencidasReceberPagar",
                    e.target.checked,
                  )
                }
                color="primary"
              />
            }
          />
        </FiltrosSecao>
      </FiltrosDrawer>
    </>
  );
}

export default MonitorFinFiltros;
